var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#C46F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 2.37172L4.91039 5.68547C4.91039 5.89516 5.03161 6 5.27403 6H6.72858C6.971 6 7.09221 5.89516 7.09221 5.68547L7.33464 2.37172C7.33464 2.25735 7.29423 2.17156 7.21342 2.11438C7.15282 2.03813 7.07201 2 6.971 2H5.03161C4.9306 2 4.83969 2.03813 4.75888 2.11438C4.69827 2.17156 4.66797 2.25735 4.66797 2.37172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 7.33301C6.36845 7.33301 6.67763 7.46827 6.92884 7.7388C7.19937 7.99001 7.33464 8.29919 7.33464 8.66634C7.33464 9.03349 7.19937 9.35233 6.92884 9.62286C6.67763 9.87407 6.36845 9.99967 6.0013 9.99967C5.63415 9.99967 5.31531 9.87407 5.04478 9.62286C4.79357 9.35233 4.66797 9.03349 4.66797 8.66634C4.66797 8.29919 4.79357 7.99001 5.04478 7.7388C5.31531 7.46827 5.63415 7.33301 6.0013 7.33301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowWarning);
export default __webpack_public_path__ + "static/media/yellow-warning.adddfe17a578234f47d03d9e0a283eb3.svg";
export { ForwardRef as ReactComponent };